(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState !== "loading") {
      fn();
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  }

  function addCustomScroll() {
    var productSection = document.querySelector('[data-section-type="product"]');
    if (!productSection) return;

    var sectionId = productSection.getAttribute("data-section-id");
    if (!sectionId) return;

    function preventTabScroll() {
      if (window.jQuery) {
        var originalAnimate = window.jQuery.fn.animate;
        window.jQuery.fn.animate = function (properties, duration, easing, complete) {
          if (properties && properties.scrollTop !== undefined) {
            if (typeof complete === "function") {
              complete.call(this);
            } else if (typeof easing === "function") {
              easing.call(this);
            } else if (typeof duration === "function") {
              duration.call(this);
            }
            return this;
          }
          return originalAnimate.call(this, properties, duration, easing, complete);
        };
      }
    }

    preventTabScroll();
  }

  ready(function () {
    setTimeout(addCustomScroll, 500);
  });

  if (window.Shopify && window.Shopify.theme) {
    document.addEventListener("shopify:section:load", function () {
      setTimeout(addCustomScroll, 500);
    });
  }
})();
